import React from 'react';

/**
 * The chrome a tab wears when it is NOT a board.
 *
 * A board tab gets its look from the widget wrapper: an eyebrow — small-caps
 * label on the figure's shoulder, 10px above, nothing below, no rule — on an
 * 18px gutter. A panel tab got whatever its component happened to bring, and
 * measured across the page that was eight different answers: gutters of 0, 16,
 * 17, 18, 21 and no title at all on six of them (Ryan, 2026-09-18: "people
 * does not match dash").
 *
 * So the construct is a component rather than markup copied per tab. Copied
 * markup is how the gutters diverged in the first place.
 *
 * USED AT THE CALL SITE, never inside a panel. Most of these panels are also
 * mounted as board widgets and on /workspace, where the widget wrapper already
 * supplies a title — wrapping inside would draw two.
 */
export default function AccountsSection({ title, children }) {
  return (
    <section className="accounts-section">
      <header className="accounts-section__head">
        <span className="accounts-section__title">{title}</span>
      </header>
      <div className="accounts-section__body">
        {children}
      </div>
    </section>
  );
}
